<script>
import {Radar} from 'vue-chartjs';

export default {
    extends: Radar,
    props:   ['answers'],
    mounted() {
        const red = [
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(1.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(2.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(3.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(4.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(5.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(6.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(7.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(8.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(9.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(10.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(11.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(12.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(13.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(14.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(15.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(16.1) === 0).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(17.1) === 0).length
        ];

        const orange = [
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(1.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(2.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(3.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(4.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(5.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(6.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(7.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(8.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(9.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(10.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(11.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(12.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(13.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(14.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(15.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(16.1) === 0.5).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(17.1) === 0.5).length
        ];

        const green = [
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(1.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(2.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(3.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(4.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(5.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(6.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(7.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(8.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(9.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(10.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(11.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(12.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(13.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(14.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(15.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(16.1) === 1).length,
            this.answers.filter(AnswerRepository => AnswerRepository.getScoreForHeadId(17.1) === 1).length
        ];

        this.renderChart({
                labels:   [
                    '1. Tillen',
                    '2. Trekken',
                    '3. Duwen',
                    '4. Houdingen',
                    '5. Manoeuvreren',
                    '6. Drukken',
                    '7. Dragen',
                    '8. Boven macht',
                    '9. Reiken',
                    '10. Beeldschermwerk',
                    '11. Zitten',
                    '12. Repeterend werk',
                    '13. Wringen',
                    '14. Staan',
                    '15. Knielen',
                    '16. Gedraaide nek',
                    '17. Transfers',
                ],
                datasets: [{
                    label:           'Oranje',
                    borderColor:     'rgb(225, 160, 38)',
                    backgroundColor: 'rgba(225, 160, 38, 0)',
                    data:            orange
                }, {
                    label:           'Rood',
                    borderColor:     'rgb(237, 0, 41)',
                    backgroundColor: 'rgba(237, 0, 41, 0)',
                    data:            red
                }, {
                    label:           'Groen',
                    borderColor:     'rgb(31, 192, 125)',
                    backgroundColor: 'rgba(31, 192, 125, 0)',
                    data:            green
                }]
            },
            {
                responsive: true,
                legend:     false,
                scale:      {
                    ticks: {
                        stepSize: 1
                    }
                }
            }
        )
    }
}
</script>
